import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client.js';

/**
 * HM-076 — Conflict resolution queue UI scaffold (Fase 2 ready).
 * In Fase 1 la coda e' vuota: GET /conflicts ritorna [].
 */
type ConflictRow = {
  id: string;
  roomId: string | null;
  reason: string;
  createdAt: string;
};

async function fetchConflicts(): Promise<{ conflicts: ConflictRow[] }> {
  return api('/conflicts');
}

export function ConflictsPage() {
  const q = useQuery({ queryKey: ['conflicts'], queryFn: fetchConflicts });
  const [openId, setOpenId] = useState<string | null>(null);
  return (
    <main style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ margin: 0 }}>Conflicts</h1>
        <Link to="/">← Dashboard</Link>
      </header>
      {q.isLoading && <p>Caricamento…</p>}
      {q.error && <p style={{ color: 'crimson' }}>{(q.error as Error).message}</p>}
      {q.data && q.data.conflicts.length === 0 && (
        <p data-testid="conflicts-empty" style={{ color: '#64748b' }}>
          Nessun conflict in coda. (In Fase 1 il sync cloud e' disattivato.)
        </p>
      )}
      {q.data && q.data.conflicts.length > 0 && (
        <ul data-testid="conflicts-list">
          {q.data.conflicts.map((c) => (
            <li key={c.id}>
              <button type="button" onClick={() => setOpenId(c.id)}>
                {c.reason} — {new Date(c.createdAt).toLocaleString()}
              </button>
            </li>
          ))}
        </ul>
      )}
      {openId && (
        <div
          // biome-ignore lint/a11y/useSemanticElements: vedi WalkInModal — overlay manuale.
          role="dialog"
          aria-modal="true"
          data-testid="conflict-resolution-modal"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15, 23, 42, 0.6)',
            display: 'grid',
            placeItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: '#fff',
              padding: 16,
              borderRadius: 8,
              width: 'min(560px, 96vw)',
            }}
          >
            <h3>Conflict {openId}</h3>
            <p style={{ fontSize: 13 }}>
              Mockup risoluzione: tieni walk-in / tieni online / forza override.
              <br />
              In Fase 1 nessuna logica reale (lista vuota).
            </p>
            <button type="button" onClick={() => setOpenId(null)}>
              Chiudi
            </button>
          </div>
        </div>
      )}
    </main>
  );
}
